import { createRestApiClient } from '..';
import { getUserToken } from '../../Utils/helper';

export const storeDataFetcher = async (params) => {
  const restApiClient = createRestApiClient();
  const url = `/new/generalTab/getStoreHomeWeb`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: { 'Mylo-In-App': false },
    })
    .then((res) => res.data);
  return data;
};
export const getCategoryDataForStoreCategoriesWeb = async () => {
  const restApiClient = createRestApiClient();
  const url = `new/generalTab/getCategoryDataForStoreCategoriesWeb`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,

      headers: { 'Mylo-In-App': false },
    })
    .then((res) => res.data);
  return data;
};
export const OtiCategoryFetcher = async (params) => {
  const restApiClient = createRestApiClient();
  const url = `api/getProducts`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
  return data;
};

export const getBogoPopupData = async (params) => {
  const restApiClient = createRestApiClient();
  const queryParams = { isForFirstTime: params.isForFirstTime };
  delete params['isForFirstTime'];
  const url = `/api/offerCart`;
  const data = await restApiClient
    .request({
      method: 'POST',
      url: url,
      data: params,
      params: queryParams,
      headers: { 'Mylo-In-App': false, 'authorization': getUserToken() },
    })
    .then((res) => res.data);
  return data;
};

export const getGeneralItemByItemId = async (itemId) => {
  const restApiClient = createRestApiClient();
  const url = `/new/generalTab/getGeneralItemByItemId`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: { itemId: itemId, userType: 'A' },
      headers: {
        'Mylo-In-App': false,
        'authorization': getUserToken(true),
      },
    })
    .then((res) => res?.data?.data);
  return data;
};
